export * from './DatePicker.component';

import { registerLocale as registerLocaleImport } from 'react-datepicker';
/** @deprecated use new date picker components instead */
export const registerLocale = registerLocaleImport;
